import { Brakesman } from './Filesystem/Helper';
import { Message, MessageTimeout, RequestProgress, sendMessage, SendMessageCallbacks } from './Communication';
import { cancelDownload } from './AppAction';
import { getPayloadEntry, SharePayloadEntry, ShareEventOrigin, ShareableEntry } from './ShareUtils';

import { wrapForSingleUse } from '@egr/xbox/utils/Helper';

import { Lock } from '@egr/wcf/modules/utils/async';

export function shareText(content: string): Promise<void> {
    return sendMessage<Message<{content: string}>>({
        type: 'share',
        action: 'message',
        arguments: {
            content
        }
    });
}

interface ShareArguments {
    save: boolean;
    pickPath: boolean;
    payload: Array<SharePayloadEntry>;
    origin?: ShareEventOrigin;
}

export async function share(
    entry: ShareableEntry,
    save: boolean,
    pickPath: boolean,
    origin?: ShareEventOrigin,
    writeLock?: Lock,
    brakesman?: Brakesman,
): Promise<void> {
    const payloadEntry: SharePayloadEntry | null = await getPayloadEntry(entry, writeLock, brakesman);

    if (payloadEntry == null) {
        return;
    }

    return shareMultiple([payloadEntry], save, pickPath, origin).promise;
}

export interface ShareRequest {
    promise: Promise<void>;
    cancel: VoidFunction;
}

export function shareMultiple<ProgressType extends RequestProgress = RequestProgress>(
    payload: Array<SharePayloadEntry>,
    save: boolean,
    pickPath: boolean,
    origin?: ShareEventOrigin,
    progressCallback?: SendMessageCallbacks<ProgressType>['progress']
): ShareRequest {
    let transactionId: number | undefined;
    const promise: Promise<void> = sendMessage<Message<ShareArguments>, void, ProgressType>(
        {
            type: 'share',
            action: 'content',
            arguments: {
                save,
                pickPath,
                payload,
                origin
            }
        },
        false,
        MessageTimeout,
        {
            transactionId: (value: number): void => {
                transactionId = value;
            },
            progress: progressCallback
        }
    );

    return {
        promise,
        cancel: wrapForSingleUse((): void => {
            if (transactionId != null) {
                return cancelDownload(transactionId);
            }
        })
    };
}